<template>
  <div class="addtaskmb-container">
    <van-nav-bar
      title="添加监控任务"
      left-arrow
      @click-left="onClickLeft"
      safe-area-inset-top fixed placeholder z-index="100"
    >
    </van-nav-bar>

    <el-form :model="addForm" ref="addForm" label-position="top" :rules="rule">
      <el-form-item label="任务名称" prop="name">
        <el-input size="small" v-model.trim="addForm.name" placeholder="若不填则为随机默认任务名"></el-input>
      </el-form-item>
      <el-form-item prop="links">
        <template #label>监控目标
          <span style="font-size: 0.7rem;color: #ccc;float: right">已输入：{{yishuru }}个，还可输入：{{ shengyu }}个</span>
        </template>
        <el-input :disabled="input_disabled" placeholder="请输入域名、链接或ip:端口、微信公众号名称、微信小程序ID，一行一个，回车换行。" size="small" type="textarea" resize="none" :rows="3" v-model="addForm.links"
                  @input="splitInput($event)"></el-input>
      </el-form-item>
      <el-row style="display: flex;">
        <el-col :span="nodeShow?11: addForm.project === 'web' ? 11 : 24">
          <el-form-item label="监控方式" prop="project">
            <el-select v-model="addForm.project" placeholder="请选择监控方式" @change="change_Type($event)"
                       style="width: 100%;">
              <el-option v-for="(item,key) in apilist" :label="item.name" :value="item.interface_name"
                         :key="key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="13" v-if="nodeShow">
          <el-form-item label="监控节点" prop="node">
            <el-select v-model="addForm.node" placeholder="请选择监控节点">
              <el-option v-for="(item,key) in nodelist" :key="key" :label="item.name"
                         :value="item.jiedianid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="13" v-if="addForm.project === 'web'">
          <el-form-item label="查询关键词" prop="content">
            <el-input v-model.trim="addForm.content" placeholder="请输入要查询的关键词"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="监控频率选择">
            <el-radio-group v-model="SeeTimesType" size="small" @change="addForm.time=''">
              <el-radio-button :label="false">推荐</el-radio-button>
              <el-radio-button :label="true">自定义</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="监控频率" prop="time" style="margin-bottom: 1rem">
            <template slot="label">
              <span @click="showTips('监控频率')">监控频率 <i class="el-icon-question"></i></span>
            </template>
            <el-input type="number" size="small" oninput="value=value.replace(/[^\d.]/g,'')" onmousewheel="return false" v-model.trim="addForm.time" v-if="SeeTimesType">
              <template slot="append">分钟</template>
            </el-input>
            <el-select size="small" v-else v-model="addForm.time" placeholder="请选择监控频率">
              <el-option label="30分钟" value="30"></el-option>
              <el-option label="5分钟" value="5"></el-option>
              <el-option label="1分钟" value="1"></el-option>
              <el-option label="1小时" value="60"></el-option>
              <el-option label="2小时" value="120"></el-option>
              <el-option label="6小时" value="360"></el-option>
              <el-option label="12小时" value="720"></el-option>
              <el-option label="24小时" value="1440"></el-option>
              <el-option label="3天" value="4320"></el-option>
              <el-option label="7天" value="10080"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <van-cell>
            <template #title>
              <span @click="showTips('自动停用')">自动停用 <i class="el-icon-question"></i></span>
            </template>
            <template #extra>
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="addForm.switch"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </template>
          </van-cell>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <van-cell>
            <template #title>
              <span @click="showTips('告警模式')">告警模式 <i class="el-icon-question"></i></span>
            </template>
            <template #extra>
              <el-radio v-model="addForm.tongzhistate" style="margin-right: 0.5rem" size="small" :label="1" border>
                异常告警
              </el-radio>
              <el-radio v-model="addForm.tongzhistate" size="small" :label="0" border style="margin-left: 0">正常告警
              </el-radio>
            </template>
          </van-cell>
        </el-col>
      </el-row>
      <!-- 执行区间模块-->

      <!-- 报警通知模块-->
      <van-cell title="是否开启报警通知">
        <template #extra>
          <el-switch
            v-model="addForm.tongzhiswitch"
            active-value="1"
            nactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </van-cell>
      <el-row>
        <el-col :span="12" >
          <el-form-item v-if="addForm.tongzhiswitch == 1" label="报警复查开关" prop="name">
            <template slot="label">
              <span @click="showTips('报警复查')">是否开启报警复查<i class="el-icon-question"></i></span>
            </template>
            <el-switch v-model="addForm.review_switch" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="addForm.tongzhiswitch== 1 &&addForm.review_switch == 1" label="报警复查次数" prop="name" :rules="[{required:true,message:'请输入报警复查次数'}]">
            <el-input-number size="small" :min="1" :max="3" v-model.trim="addForm.review_count"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="addForm.tongzhiswitch">
        <el-form-item label="通知渠道">
          <van-grid :column-num="4" :border="false">
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="1" @change="changeTz()">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-icon-test"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <!-- 微信-->
              <el-radio v-model="addForm.tongzhitype" label="4" @change="changeTz()">
               <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-weixin"></use>
                  </svg>
               </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="5" @change="changeTz()">
                <span>
                  <svg class="icon dingding_icon" aria-hidden="true">
                    <use xlink:href="#icon-dingding"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="7" @change="changeTz()">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-icon-test1"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="2" @change="changeTz()">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-xinxiduanxinsixinduihua"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="3" @change="changeTz()">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-dianhuabeifen"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="8" @change="changeTz()">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-feishu"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
            <van-grid-item>
              <el-radio v-model="addForm.tongzhitype" label="6" @change="changeTz()">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-telegram"></use>
                  </svg>
                </span>
              </el-radio>
            </van-grid-item>
          </van-grid>
        </el-form-item>


        <el-form-item label="通知账户" prop="mail" class="noticeAccount">
          <!--微信通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==4 && wx_contactlist.length != 0">
            <el-option v-for="item in wx_contactlist" :key="item" :label="item.nickname" :value="item.open_id">
              {{ item.nickname }}
            </el-option>
          </el-select>
          <!--钉钉通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype==5 && notice_dingtalk.length != 0">
            <el-option v-for="item in notice_dingtalk" :key="item" :label="item.name" :value="item.id">{{
                item.name
              }}
            </el-option>
          </el-select>
          <!--企业微信通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype == 7 && notice_enterprisewechat.length != 0">
            <el-option v-for="item in notice_enterprisewechat" :key="item" :label="item.name" :value="item.id">
              {{ item.name }}
            </el-option>
          </el-select>
          <!--飞书通知选择-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype == 8 && notice_feishu.length != 0">
            <el-option v-for="item in notice_feishu" :key="item" :label="item.name" :value="item.id">{{
                item.name
              }}
            </el-option>
          </el-select>
          <!--电报-->
          <el-select v-model="addForm.mail" v-if="addForm.tongzhitype == 6 && notice_telegram.length != 0">
            <el-option v-for="item in notice_telegram" :key="item" :label="item.type=='group'?item.name:item.username"
                       :value="item.chat_id">
              <span>{{ item.type == 'group' ? '群聊' : '个人' }}：{{
                  item.type == 'group' ? item.name : item.username
                }}</span>
            </el-option>
          </el-select>
          <el-autocomplete
            v-if="addForm.tongzhitype!=4 && addForm.tongzhitype!=5 && addForm.tongzhitype!=6 && addForm.tongzhitype!=7 && addForm.tongzhitype!= 8"
            v-model="addForm.mail"
            :fetch-suggestions="querySearch"
            @select="handleSelect($event)"
            ref="autocompleteIput"
            placeholder="请选择或输入"
          >
            <template slot-scope="{ item }">
              <span v-if="item.email">{{ item.email }}</span>
              <span v-else-if="item.phone">{{ item.phone }}</span>
            </template>
          </el-autocomplete>
          <p v-if="addForm.tongzhitype==4 && wx_contactlist.length==0" style="margin: 0;color: #666666">
            您当前未绑定通知微信,请前往绑定:
            <el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:3}})" type="primary"
                     :underline="false">立即前往
            </el-link>
          </p>
          <p v-if="addForm.tongzhitype==5 && notice_dingtalk.length==0" style="margin: 0;color: #666666">
            您当前未设定钉钉通知机器人,请前往设定:
            <el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:4}})" type="primary"
                     :underline="false">立即前往
            </el-link>
          </p>
          <p v-if="addForm.tongzhitype==6 && notice_telegram.length==0" style="margin: 0;color: #666666">
            您当前未设定电报通知账户,请前往设定:
            <el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:5}})" type="primary"
                     :underline="false">立即前往
            </el-link>
          </p>
          <p v-if="addForm.tongzhitype==7 && notice_enterprisewechat.length==0" style="margin: 0;color: #666666">
            您当前未设定企业微信通知账户,请前往设定:
            <el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:6}})" type="primary"
                     :underline="false">立即前往
            </el-link>
          </p>
          <p v-if="addForm.tongzhitype==8 && notice_feishu.length==0" style="margin: 0;color: #666666">
            您当前未设定飞书通知账户,请前往设定:
            <el-link @click.stop="$router.push({path:'/center/noticeAccount',query:{activeName:7}})" type="primary"
                     :underline="false">立即前往
            </el-link>
          </p>
        </el-form-item>
      </div>

      <!-- 执行时间段-->
      <van-cell>
        <template #title>
          <span @click="showTips('执行时间段')">
            执行时间段 <i class="el-icon-question"></i>
          </span>
        </template>
        <template #extra>
          <el-switch
            :active-value="1"
            :inactive-value="0"
            v-model="addForm.timeswitch"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </van-cell>
      <el-row class="executionTime" v-if="addForm.timeswitch">
        <el-col :span="24">
          <el-form-item prop="section_time">
            <el-input placeholder="选择时间" readonly @click.native="showDatePick = true"
                      :value="revealStartTime && revealEndTime ? revealStartTime+' 至 '+revealEndTime : ''">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--       日期选择-->
      <van-calendar ref="calendar" title="选择执行时间段" color="#1989fa" v-model="showDatePick" :max-date="maxDate"
                    type="range" allow-same-day @select="selectDate" get-container="body" :default-date="null"
                    safe-area-inset-bottom :show-confirm="false">
        <template #footer>
          <van-cell title="开始时间:" :value="revealStartTime" @click="editSelectTime('start')"></van-cell>
          <van-cell title="结束时间:" :value="revealEndTime" @click="editSelectTime('end')"></van-cell>
          <div style="display: flex">
            <van-button size="small" block round type="info" native-type="button" @click="confirmDate">确定</van-button>
            <van-button v-show="revealStartTime || revealEndTime" size="small" block round native-type="button" @click="handleClearDate">
              重置
            </van-button>
          </div>
        </template>
      </van-calendar>
      <!-- 时间选择 -->
      <van-popup v-model="showTimePick" position="bottom" get-container="body" safe-area-inset-bottom :close-on-click-overlay="false">
        <van-datetime-picker
          ref="dateTimePickerRef"
          :title="timePickTitle"
          v-model="currentTime"
          @confirm="selectTime"
          @cancel="cancelSelectTime"
          type="time"
          :min-hour="0"
          :max-hour="23"
          :formatter="timeFormat"
        >
        </van-datetime-picker>
      </van-popup>
      <!-- 回调接口模块-->
      <van-cell title="是否开启回调通知">
        <template #extra>
          <el-switch v-model="addForm.callbackurlswitch"
                     active-value="1"
                     nactive-value="0"
                     active-color="#13ce66"
                     inactive-color="#ff4949"
          >
          </el-switch>
        </template>
      </van-cell>
      <div v-if="addForm.callbackurlswitch">
        <el-form-item label="接口地址" prop="callbackurl">
          <el-input placeholder="链接需以http://或https://开头" size="small" v-model.trim="addForm.callbackurl">
            <el-select style="width: 100px" slot="append" v-model="addForm.callbackurl_type" placeholder="请选择">
              <el-option label="GET" value="0"></el-option>
              <el-option label="POST" value="1"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="回调变量说明">
          <div class="VarS">
            <p>{url} : 表示被监控目标，返回示例值：google.com</p>
            <p>{type} : 表示检测类型，返回示例值：被墙/污染检测</p>
            <p>{status} : 表示目标状态，返回示例值：200为正常，201为异常</p>
            <p>{reason} : 表示原因或详情，返回示例值：被墙</p>
            <p style="margin-top: 15px">示例: http://<span style="color:red">domain</span>/?url={url}&type={type}&status={status}&reason={reason}
            </p>
            <p style="color:red;">提示：回调地址必须返回ok</p>
          </div>
        </el-form-item>
      </div>
      <div class="dialog-footer" style="text-align: center">
        <el-button type="primary" :loading="addloading" @click="onsubmit()">添 加</el-button>
        <el-button native-type="button" @click="onClickLeft">返 回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import '@/../public/iconfont/iconfont'
import '@/../public/iconfont/iconfont1'

export default {
  data() {
    const validatePass2 = (rule, value, callback) => {
      const emailreg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (this.addForm.tongzhitype == 1 && !emailreg.test(value)) {
        callback(new Error('请输入正确邮箱号!'))
      } else if (this.addForm.tongzhitype == 2 || this.addForm.tongzhitype == 3) {
        const reg = /^1[3|4|5|7|8|9]\d{9}$/
        const reg2 = /^0\d{2,3}\d{7,8}$/
        if (reg2.test(value) || reg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机或座机号!'))
        }
      } else {
        callback()
      }
    }
    const chaochu = (rule, value, callback) => {
      if (this.shengyu < 0) {
        callback(new Error('监控额度不足,请删减链接!'))
      } else {
        callback()
      }
    }
    return {
      input_disabled: false,
      yishuru: 0,
      shengyu: this.$store.state.package_purchased_monitor + this.$store.state.monitor - this.$store.state.monitored,
      nodeShow: false,//是否显示选择节点
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000
        }
      },
      timeRange:[],
      // 日期选择器
      showDatePick: false,
      // 时间选择器
      showTimePick: false,
      // 开始日期
      startDate: '',
      // 结束日期
      endDate: '',
      // 开始时间
      startTime: '',
      // 结束时间
      endTime: '',
      // 时间选择标题
      timePickTitle: '',
      // 当前选中的时间
      currentTime: new Date().getHours().toString().padStart(2, '0') + ':' + new Date().getMinutes().toString().padStart(2, '0'),
      // 日期最大值
      maxDate: new Date(2030, 0, 31),
      addForm: {
        name: '',//名称
        links: '',//链接
        url: '',
        grouping_id:0,
        project: '',//检测方式
        node: '',//检测节点
        content: '',//查询关键词
        time: '',//检测频率
        tongzhiswitch: '1', // 通知开关
        callbackurlswitch: '0', // 回调开关
        tongzhistate: 1,//告警模式
        tongzhitype: '1', //通知方式
        review_switch:0,
        review_count:1,
        callbackurl: '', // 回调参数
        mail: '', // 通知账户
        stateswitch: 1,
        switch: 1,
        timeswitch: '',//执行区间开关
        section_time: [],//执行区间
        callbackurl_type: '1',
        page: 1,
        eachpage: 5,
      },
      rule: {
        name:[
          { min: 1,max:6, message: '任务名不得超过6个字符', trigger: 'blur' },
        ],
        links:[
          { required: true, message: '请输入监控目标链接', trigger: 'blur' },
          { validator:chaochu,trigger: ['blur', 'change']}
        ],
        project:[
          { required: true, message: '请选择监控方式', trigger: 'change' },
        ],
        node:[
          { required: true, message: '请选择监控节点', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入要查询的关键词', trigger: 'change' },
        ],
        time:[
          { required: true, message: '请选择监控频率', trigger: 'change' },
        ],
        mail:[
          { required: true, message: '请选择通知账户', trigger: 'change' },
          { validator: validatePass2, trigger: 'blur' },
        ],
        callbackurl:[
          { required: true, message:'请输入回调链接', trigger: 'blur' },
          { pattern: /http[s]{0,1}:\/\/([\w.]+\/?)\S*/, message: '请输入带http://或https://开头的链接', trigger: 'blur' },
        ],
        section_time:[
          { required: true, message: '请选择执行时间段', trigger: 'blur' }
        ],
      },
      contactlist: [],
      nodelist: [],
      apilist: [],
      wx_contactlist: [],
      notice_dingtalk: [],
      notice_telegram: [],
      notice_enterprisewechat: [],
      notice_feishu: [],
      SeeTimesType: false,
      addloading: false,
    }
  },
  created() {
    this.getapilist()
    this.getnodelist()
  },
  beforeUpdate() {
    if(this.$store.state.package_purchased_monitor + this.$store.state.monitor - this.$store.state.monitored <= 0){
      this.onClickLeft()
    }
  },
  computed: {
    revealStartTime() {
      if (this.startDate && this.startTime) {
        return this.startDate + ' ' + this.startTime
      } else {
        return ''
      }
    },
    revealEndTime() {
      if (this.endDate && this.endTime) {
        return this.endDate + ' ' + this.endTime
      } else {
        return ''
      }
    }
  },
  watch: {
    revealStartTime(val){
      if (!val) {
        return
      }
      if (this.addForm.section_time[0] > this.addForm.section_time[1]) {
        this.$notify({type:'danger',message:'开始时间不能大于结束时间'})
        this.handleClearDate()
      }
    },
    revealEndTime(val) {
      if (!val) {
        return
      }
      if (this.addForm.section_time[0] > this.addForm.section_time[1]) {
        this.$notify({type:'danger',message:'开始时间不能大于结束时间'})
        this.handleClearDate()
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push('monitor')
    },
    // 重置日历数据
    handleClearDate() {
      this.$refs.calendar.reset()
      this.startDate = this.endDate = this.startTime = this.endTime = ''
      this.addForm.section_time = []
    },
    // 时间过滤器
    dateFormat(time) {
      const y = time.getFullYear()
      const m = (time.getMonth() + 1 + '').padStart(2, '0')
      const d = (time.getDate() + '').padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    // 确认按钮
    confirmDate() {
        if(this.timeRange[0] == null || this.timeRange[1] == null ){
          return this.$notify({type:'danger',message:'请选择开始或结束时间'})
        }
        if(this.revealStartTime && this.revealEndTime){
          this.addForm.section_time[0] = Date.parse(new Date(this.revealStartTime).toString())
          this.addForm.section_time[1] = Date.parse(new Date(this.revealEndTime).toString())
          this.showDatePick = false
        }else{
          this.$notify({type:'danger',message:'请选择开始或结束时间'})
        }
    },
    // 点击日期触发
    selectDate(val) {
      this.timeRange = val
      this.showTimePick = true
      if (val[0]) {
        this.startDate = this.dateFormat(val[0])
        this.timePickTitle = '开始时间'
      }
      if (val[1]) {
        this.endDate = this.dateFormat(val[1])
        this.timePickTitle = '结束时间'
      }
    },
    // 时间选择确定按钮
    selectTime() {
      if (this.timePickTitle === '开始时间') {
        this.startTime = this.currentTime
        if(this.timeRange[1] == null){
          this.endDate = this.endTime = ''
        }
        this.addForm.section_time[0] = Date.parse(new Date(this.revealStartTime).toString())
      }
      if (this.timePickTitle === '结束时间') {
        this.endTime = this.currentTime
        this.addForm.section_time[1] = Date.parse(new Date(this.revealEndTime).toString())
      }
      this.showTimePick = false
    },
    // 编辑时间
    editSelectTime(type){
      switch (type){
        case 'start':
          if (this.startDate && this.startTime) {
            this.showTimePick = true
            this.timePickTitle = '开始时间'
            if(this.timeRange[1] == null){
              this.endDate = this.endTime = ''
            }
          }else{
            this.$notify({type:'warning',message:'请先点击日历选择日期'})
          }
          break
        case 'end':
          if (this.endDate && this.endTime) {
            this.showTimePick = true
            this.timePickTitle = '结束时间'
          }else{
            this.$notify({type:'warning',message:'请先点击日历选择日期'})
          }
          break
      }
    },
    // 取消选择时间
    cancelSelectTime(){
      this.showTimePick = false
      if(this.timePickTitle === '开始时间'){
        this.startTime = '0:00'
        if(this.timeRange[1] == null){
          this.endDate = this.endTime = ''
        }
      }
      if(this.timePickTitle === '结束时间'){
        this.endTime = '0:00'
      }
    },
    // 给时间添加后缀
    timeFormat(type, val) {
      switch (type) {
        case 'hour':
          return val + '点'
        case 'minute':
          return val + '分'
      }
      return val
    },
    // 提示消息
    showTips(title) {
      switch (title) {
        case '监控频率':
          this.$dialog.alert({ title:'提示', message: '每隔多长时间执行一次' })
          break
        case '自动停用':
          this.$dialog.alert({ title:'提示', message: '开启本功能，根据您设置的告警模式，被监控目标状态发生变化，通知或回调后自动关闭任务，从而避免多次重复提醒，节省账号检测点。(建议不要关闭此功能)' })
          break
        case '告警模式':
          this.$dialog.alert({ title:'提示', message: '选择被监控目标在何种状态下报警' })
          break
        case '执行时间段':
          this.$dialog.alert({ title:'提示', message: '若开启，本任务则在设置的时间内执行。若关闭，则一直执行。若任务未开启，则时间段执行不生效。若当前时间大于终止时间，则自动关闭本任务。' })
          break
        case '报警复查':
          this.$dialog.alert({ title:'提示', message: '设置监控复查次数，可以降低某些接口受网络波动影响误报几率。' })
          break
      }
    },
    // 获取监控方式列表
    async getapilist() {
      const { data } = await this.$http.post('/apiinterface/apilist')
      if (data.status == 'success') {
        this.apilist = data.data
        this.$store.commit('setOther', {
          name: 'apilist',
          value: data.data
        })
      } else {
        this.$notify({
          type: 'danger',
          message: data.msg
        })
      }
    },
    // 获取节点列表
    async getnodelist() {
      const { data } = await this.$http.post('/apiinterface/nodelist')
      if (data.status == 'success') {
        this.nodelist = data.data
        this.$store.commit('setOther', {
          name: 'nodelist',
          value: data.data
        })
      } else {
        this.$notify({
          type: 'danger',
          message: data.msg
        })
      }
    },
    //输入框输入检测
    splitInput(val) {
      let arr = val.split('\n')
      arr = arr.filter(item => {
        return item.trim() != ''
      })
      this.yishuru = arr.length
      this.shengyu = this.$store.state.package_purchased_monitor + this.$store.state.monitor - this.$store.state.monitored - arr.length
      this.addForm.url = arr.join('||')
    },
    handleSelect(item) {
      if (this.addForm.tongzhitype == 1) {
        this.addForm.mail = item.email
      } else if (this.addForm.tongzhitype == 2 || this.addForm.tongzhitype == 3) {
        this.addForm.mail = item.phone
      }
      this.$refs.addForm.clearValidate('mail')
    },
    //更改通知方式
    changeTz() {
      let field = this.$refs.addForm.fields
      field.map(i => {
        if (i.prop === 'mail') {  //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
          i.resetField()
          return false
        }
      })
      if (this.addForm.tongzhitype == 4) {
        this.wx_contactlist = this.$store.state.notice_wechat
      } else if (this.addForm.tongzhitype == 5) {
        this.notice_dingtalk = this.$store.state.notice_dingtalk
      } else if (this.addForm.tongzhitype == 6) {
        this.notice_telegram = this.$store.state.notice_telegram
      } else if (this.addForm.tongzhitype == 7) {
        this.notice_enterprisewechat = this.$store.state.notice_enterprisewechat
      } else if (this.addForm.tongzhitype == 8) {
        this.notice_feishu = this.$store.state.notice_feishu
      }
      this.addForm.mail = ''
    },
    //自动填写
    querySearch(queryString, cb) {
      this.contactlist = []
      if (this.addForm.tongzhitype == 1) {
        this.contactlist = this.$store.state.notice_email
      } else if (this.addForm.tongzhitype == 2 || this.addForm.tongzhitype == 3) {
        this.contactlist = this.$store.state.notice_phone
      }
      cb(this.contactlist)
    },
    DialogClose() {
      this.$refs.addForm.resetFields()
      this.$emit('closeView', false)
    },
    //提交
    onsubmit() {
      this.$refs.addForm.validate(async (bool, obj) => {
        if (bool) {
          this.addloading = true
          try {
            const { data } = await this.$http.post('/task/taskadd', this.addForm)
            if (data.status == 'success') {
              this.$refs.addForm.resetFields()
              // 修改仓库中已用任务额度
              this.$store.commit('setOther', {
                name: 'monitored',
                value: data.total
              })
              await this.$router.push('monitor')
              this.$notify({
                type: 'success',
                message: '添加成功'
              })
            } else {
              this.addloading = false
              this.$notify({
                type: 'danger',
                message: data.msg
              })
            }
          } catch (e) {
            this.addloading = false
            this.$notify({
              type: 'danger',
              message: '网络异常,请稍后重试'
            })
          }
        } else {
          this.$notify({
            type: 'danger',
            message: obj[Object.keys(obj)[0]][0].message
          })
        }
      })
    },
    //判断是否显示选择节点
    change_Type(val) {
      let index = this.$store.state.apilist.findIndex(item => item.interface_name == val)
      if (this.$store.state.apilist[index].nodeswitch == 1) {
        this.nodeShow = true
        this.addForm.node = ''
      } else {
        this.nodeShow = false
        this.addForm.node = ''
      }
      if (val == 'qiang') {
        let arr = this.$store.state.nodelist.filter(item => {
          return item.country == 'cn'
        })
        this.nodelist = arr
      } else {
        this.nodelist = this.$store.state.nodelist
      }
    }
  }
}
</script>

<style lang="less" scoped>
.addtaskmb-container {
  height: 100vh;
  overflow: auto;
  background-color: #ffffff;
  padding: 0.5rem 1rem 1rem;
  .el-form {
    .el-divider {
      //margin: 40px 0 20px;

      /deep/ .el-divider__text {
        font-weight: 700;
        color: #666;
      }
    }
  }

  .executionTime {
    padding-bottom: 1rem;
    display: flex;
    align-items: center;

  }

  .el-form-item {
    margin-bottom: 15px;

    /deep/ .el-form-item__label {
      width: 100%;
      line-height: 30px;
      padding: 0;
      color: #617182;
    }

    /deep/.el-form-item__content {
      line-height: 100%;
    }
  }

  .noticeAccount {
    margin-bottom: 1rem;

    .el-select {
      width: 100%;
    }

    .el-autocomplete {
      width: 100%;
    }
  }

  .icon {
    margin: 0;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
  }

  .dingding_icon {
    width: 1.7em;
    height: 1.7em;
  }

  .VarS {
    p {
      margin: 10px 0;
      line-height: 1;
      font-size: 13px;
      color: #666;
    }
  }

  /deep/ .van-cell {
    padding-left: 0;
    padding-right: 0;

    .van-cell__title {
      display: flex;
      align-items: center;
      color: #617182;
    }
  }

  // 清除van-cell下划线
  .van-cell::after {
    display: none;
  }
}

/deep/ .van-calendar {
  .van-calendar__footer {
    padding: 0 1rem 1rem;
  }
}

</style>
